export const API_URL = process.env.REACT_APP_PYTHON_API_URL;
